// extracted by mini-css-extract-plugin
export default {"btn":"Dropdown--btn--NXJxy","icon":"Dropdown--icon--tc6Cr","list":"Dropdown--list--UN09u","item":"Dropdown--item--lMcDw"};